export const stringUtils = {
  serialize,
  toInputUppercase,
  toInputLowerCase,
  getFileNameFromUrl,
  converterMedidas
};

function serialize(obj) {
  let str = '?' + Object.keys(obj).reduce(function (a, k) {
    a.push(k + '=' + encodeURIComponent(obj[k]));
    return a;
  }, []).join('&');
  return str;
}

function toInputUppercase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toUpperCase();
  e.target.setSelectionRange(start, end);
};

function toInputLowerCase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toLowerCase();
  e.target.setSelectionRange(start, end);
};

function getFileNameFromUrl(url) {
  var split = url.split('/')

  return split[split.length - 1]
}

function converterMedidas(texto) {
  const unidades = [
    { menor: 'G', maior: 'KG', fator: 1000 },
    { menor: 'ML', maior: 'L', fator: 1000 }
  ];

  // Regex para pegar valor numérico seguido da unidade
  return texto.replace(/(\d*\.?\d+)\s*(G|KG|ML|L)\b/gi, (match, valor, unidade) => {
    valor = parseFloat(valor);

    for (const u of unidades) {
      if (unidade.toUpperCase() === u.menor && valor >= u.fator) {
        return `${(valor / u.fator).toFixed(2).replace('.', ',')}${u.maior}`;
      }
      if (unidade.toUpperCase() === u.maior && valor < 1) {
        return `${(valor * u.fator).toFixed(0)}${u.menor}`;
      }
    }

    return match; // se não precisa converter, mantém igual
  });
}
